/**
 * 学习乐园 · 连连看题材包：成语接龙（lianliankan/pack-chengyu.js）
 * ---------------------------------------------------------------------------
 * 关联型配对：前半连后半（「画蛇」连「添足」）。note 存完整成语——
 * 配错时反馈「『画蛇』的正确搭档是『添足』（画蛇添足）」，消除时也把完整
 * 成语展示给用户：配上的那一瞬就是学成语的那一瞬（栏目「即时且可解释」口径）。
 */
(function (global) {
  'use strict';
  var PACKS = global.STLLK_PACKS = global.STLLK_PACKS || {};

  PACKS.chengyu = {
    id: 'chengyu',
    name: '成语接龙',
    hint: '前半连后半，配上就报全成语',
    kind: 'rel',
    cols: 6,
    rows: 6,
    pairs: [
      { l: '画蛇', r: '添足', note: '画蛇添足' },
      { l: '亡羊', r: '补牢', note: '亡羊补牢' },
      { l: '守株', r: '待兔', note: '守株待兔' },
      { l: '掩耳', r: '盗铃', note: '掩耳盗铃' },
      { l: '拔苗', r: '助长', note: '拔苗助长' },
      { l: '刻舟', r: '求剑', note: '刻舟求剑' },
      { l: '狐假', r: '虎威', note: '狐假虎威' },
      { l: '望梅', r: '止渴', note: '望梅止渴' },
      { l: '卧薪', r: '尝胆', note: '卧薪尝胆' },
      { l: '破釜', r: '沉舟', note: '破釜沉舟' },
      { l: '完璧', r: '归赵', note: '完璧归赵' },
      { l: '负荆', r: '请罪', note: '负荆请罪' },
      { l: '纸上', r: '谈兵', note: '纸上谈兵' },
      { l: '熟能', r: '生巧', note: '熟能生巧' },
      { l: '水滴', r: '石穿', note: '水滴石穿' },
      { l: '愚公', r: '移山', note: '愚公移山' },
      { l: '精卫', r: '填海', note: '精卫填海' },
      { l: '夸父', r: '逐日', note: '夸父逐日' },
      { l: '八仙', r: '过海', note: '八仙过海' },
      { l: '邯郸', r: '学步', note: '邯郸学步' },
      { l: '东施', r: '效颦', note: '东施效颦' },
      { l: '塞翁', r: '失马', note: '塞翁失马' },
      { l: '叶公', r: '好龙', note: '叶公好龙' },
      { l: '画龙', r: '点睛', note: '画龙点睛' },
      { l: '对牛', r: '弹琴', note: '对牛弹琴' },
      { l: '一箭', r: '双雕', note: '一箭双雕' },

      /* —— 寓言与典故 —— */
      { l: '螳螂', r: '捕蝉', note: '螳螂捕蝉' },
      { l: '黄粱', r: '一梦', note: '黄粱一梦' },
      { l: '井底', r: '之蛙', note: '井底之蛙' },
      { l: '坐井', r: '观天', note: '坐井观天' },
      { l: '杯弓', r: '蛇影', note: '杯弓蛇影' },
      { l: '杞人', r: '忧天', note: '杞人忧天' },
      { l: '郑人', r: '买履', note: '郑人买履' },
      { l: '买椟', r: '还珠', note: '买椟还珠' },
      { l: '滥竽', r: '充数', note: '滥竽充数' },
      { l: '自相', r: '矛盾', note: '自相矛盾' },
      { l: '缘木', r: '求鱼', note: '缘木求鱼' },
      { l: '螳臂', r: '当车', note: '螳臂当车' },
      { l: '管中', r: '窥豹', note: '管中窥豹' },
      { l: '一叶', r: '障目', note: '一叶障目' },
      { l: '盲人', r: '摸象', note: '盲人摸象' },
      { l: '虎头', r: '蛇尾', note: '虎头蛇尾' },
      { l: '画饼', r: '充饥', note: '画饼充饥' },
      { l: '南辕', r: '北辙', note: '南辕北辙' },
      { l: '削足', r: '适履', note: '削足适履' },
      { l: '女娲', r: '补天', note: '女娲补天' },
      { l: '后羿', r: '射日', note: '后羿射日' },
      { l: '开天', r: '辟地', note: '开天辟地' },
      { l: '凿壁', r: '偷光', note: '凿壁偷光' },
      { l: '囊萤', r: '映雪', note: '囊萤映雪' },
      { l: '悬梁', r: '刺股', note: '悬梁刺股' },
      { l: '闻鸡', r: '起舞', note: '闻鸡起舞' },
      { l: '铁杵', r: '成针', note: '铁杵成针' },
      { l: '指鹿', r: '为马', note: '指鹿为马' },
      { l: '三顾', r: '茅庐', note: '三顾茅庐' },
      { l: '鞠躬', r: '尽瘁', note: '鞠躬尽瘁' },
      { l: '背水', r: '一战', note: '背水一战' },
      { l: '四面', r: '楚歌', note: '四面楚歌' },
      { l: '十面', r: '埋伏', note: '十面埋伏' },
      { l: '明修', r: '栈道', note: '明修栈道' },
      { l: '暗度', r: '陈仓', note: '暗度陈仓' },
      { l: '风声', r: '鹤唳', note: '风声鹤唳' },
      { l: '草木', r: '皆兵', note: '草木皆兵' },
      { l: '势如', r: '破竹', note: '势如破竹' },
      { l: '高山', r: '流水', note: '高山流水' },
      { l: '入木', r: '三分', note: '入木三分' },

      /* —— 勤学励志 —— */
      { l: '温故', r: '知新', note: '温故知新' },
      { l: '触类', r: '旁通', note: '触类旁通' },
      { l: '融会', r: '贯通', note: '融会贯通' },
      { l: '博览', r: '群书', note: '博览群书' },
      { l: '学海', r: '无涯', note: '学海无涯' },
      { l: '天道', r: '酬勤', note: '天道酬勤' },
      { l: '厚积', r: '薄发', note: '厚积薄发' },
      { l: '敏而', r: '好学', note: '敏而好学' },
      { l: '不耻', r: '下问', note: '不耻下问' },
      { l: '诲人', r: '不倦', note: '诲人不倦' },
      { l: '锲而', r: '不舍', note: '锲而不舍' },
      { l: '金石', r: '可镂', note: '金石可镂' },
      { l: '持之', r: '以恒', note: '持之以恒' },
      { l: '精益', r: '求精', note: '精益求精' },
      { l: '百尺', r: '竿头', note: '百尺竿头' },
      { l: '更进', r: '一步', note: '更进一步' },
      { l: '绳锯', r: '木断', note: '绳锯木断' },
      { l: '全神', r: '贯注', note: '全神贯注' },
      { l: '聚精', r: '会神', note: '聚精会神' },
      { l: '专心', r: '致志', note: '专心致志' },
      { l: '心无', r: '旁骛', note: '心无旁骛' },
      { l: '脚踏', r: '实地', note: '脚踏实地' },
      { l: '实事', r: '求是', note: '实事求是' },
      { l: '只争', r: '朝夕', note: '只争朝夕' },
      { l: '夜以', r: '继日', note: '夜以继日' },
      { l: '废寝', r: '忘食', note: '废寝忘食' },
      { l: '分秒', r: '必争', note: '分秒必争' },
      { l: '乘风', r: '破浪', note: '乘风破浪' },
      { l: '逆流', r: '而上', note: '逆流而上' },
      { l: '力争', r: '上游', note: '力争上游' },
      { l: '发愤', r: '图强', note: '发愤图强' },
      { l: '百折', r: '不挠', note: '百折不挠' },
      { l: '坚持', r: '不懈', note: '坚持不懈' },
      { l: '有志', r: '竟成', note: '有志竟成' },
      { l: '鹏程', r: '万里', note: '鹏程万里' },
      { l: '马到', r: '成功', note: '马到成功' },
      { l: '一帆', r: '风顺', note: '一帆风顺' },
      { l: '前程', r: '似锦', note: '前程似锦' },

      /* —— 带数字的 —— */
      { l: '一诺', r: '千金', note: '一诺千金' },
      { l: '一鸣', r: '惊人', note: '一鸣惊人' },
      { l: '一视', r: '同仁', note: '一视同仁' },
      { l: '一丝', r: '不苟', note: '一丝不苟' },
      { l: '一尘', r: '不染', note: '一尘不染' },
      { l: '一见', r: '如故', note: '一见如故' },
      { l: '一日', r: '千里', note: '一日千里' },
      { l: '一落', r: '千丈', note: '一落千丈' },
      { l: '一马', r: '当先', note: '一马当先' },
      { l: '一举', r: '两得', note: '一举两得' },
      { l: '一劳', r: '永逸', note: '一劳永逸' },
      { l: '一鼓', r: '作气', note: '一鼓作气' },
      { l: '一望', r: '无际', note: '一望无际' },
      { l: '一言', r: '九鼎', note: '一言九鼎' },
      { l: '四通', r: '八达', note: '四通八达' },
      { l: '五体', r: '投地', note: '五体投地' },
      { l: '六神', r: '无主', note: '六神无主' },
      { l: '七上', r: '八下', note: '七上八下' },
      { l: '八面', r: '威风', note: '八面威风' },
      { l: '九牛', r: '一毛', note: '九牛一毛' },
      { l: '十全', r: '十美', note: '十全十美' },
      { l: '百发', r: '百中', note: '百发百中' },
      { l: '百步', r: '穿杨', note: '百步穿杨' },
      { l: '百感', r: '交集', note: '百感交集' },
      { l: '百家', r: '争鸣', note: '百家争鸣' },
      { l: '百花', r: '齐放', note: '百花齐放' },
      { l: '千方', r: '百计', note: '千方百计' },
      { l: '千军', r: '万马', note: '千军万马' },
      { l: '千言', r: '万语', note: '千言万语' },
      { l: '千丝', r: '万缕', note: '千丝万缕' },
      { l: '千钧', r: '一发', note: '千钧一发' },
      { l: '万紫', r: '千红', note: '万紫千红' },
      { l: '万众', r: '一心', note: '万众一心' },
      { l: '万水', r: '千山', note: '万水千山' },
      { l: '万籁', r: '俱寂', note: '万籁俱寂' },
      { l: '三心', r: '二意', note: '三心二意' },
      { l: '两面', r: '三刀', note: '两面三刀' },
      { l: '五湖', r: '四海', note: '五湖四海' },
      { l: '九霄', r: '云外', note: '九霄云外' },
      { l: '数不', r: '胜数', note: '数不胜数' },
      { l: '面面', r: '俱到', note: '面面俱到' },

      /* —— 神态与心情 —— */
      { l: '眉飞', r: '色舞', note: '眉飞色舞' },
      { l: '手舞', r: '足蹈', note: '手舞足蹈' },
      { l: '目不', r: '转睛', note: '目不转睛' },
      { l: '心平', r: '气和', note: '心平气和' },
      { l: '心慌', r: '意乱', note: '心慌意乱' },
      { l: '心旷', r: '神怡', note: '心旷神怡' },
      { l: '头晕', r: '目眩', note: '头晕目眩' },
      { l: '面红', r: '耳赤', note: '面红耳赤' },
      { l: '汗流', r: '浃背', note: '汗流浃背' },
      { l: '喜出', r: '望外', note: '喜出望外' },
      { l: '欣喜', r: '若狂', note: '欣喜若狂' },
      { l: '心花', r: '怒放', note: '心花怒放' },
      { l: '眉开', r: '眼笑', note: '眉开眼笑' },
      { l: '笑逐', r: '颜开', note: '笑逐颜开' },
      { l: '捧腹', r: '大笑', note: '捧腹大笑' },
      { l: '哭笑', r: '不得', note: '哭笑不得' },
      { l: '愁眉', r: '苦脸', note: '愁眉苦脸' },
      { l: '坐立', r: '不安', note: '坐立不安' },
      { l: '提心', r: '吊胆', note: '提心吊胆' },
      { l: '心惊', r: '胆战', note: '心惊胆战' },
      { l: '大惊', r: '失色', note: '大惊失色' },
      { l: '惊慌', r: '失措', note: '惊慌失措' },
      { l: '手忙', r: '脚乱', note: '手忙脚乱' },
      { l: '目瞪', r: '口呆', note: '目瞪口呆' },
      { l: '张口', r: '结舌', note: '张口结舌' },
      { l: '精神', r: '抖擞', note: '精神抖擞' },
      { l: '生龙', r: '活虎', note: '生龙活虎' },
      { l: '龙争', r: '虎斗', note: '龙争虎斗' },

      /* —— 说话与文字 —— */
      { l: '出口', r: '成章', note: '出口成章' },
      { l: '妙笔', r: '生花', note: '妙笔生花' },
      { l: '力透', r: '纸背', note: '力透纸背' },
      { l: '信手', r: '拈来', note: '信手拈来' },
      { l: '滔滔', r: '不绝', note: '滔滔不绝' },
      { l: '夸夸', r: '其谈', note: '夸夸其谈' },
      { l: '理直', r: '气壮', note: '理直气壮' },
      { l: '义正', r: '辞严', note: '义正辞严' },
      { l: '振振', r: '有词', note: '振振有词' },
      { l: '异口', r: '同声', note: '异口同声' },
      { l: '众口', r: '一词', note: '众口一词' },
      { l: '人云', r: '亦云', note: '人云亦云' },
      { l: '随声', r: '附和', note: '随声附和' },
      { l: '捕风', r: '捉影', note: '捕风捉影' },
      { l: '空穴', r: '来风', note: '空穴来风' },
      { l: '老生', r: '常谈', note: '老生常谈' },
      { l: '赞不', r: '绝口', note: '赞不绝口' },
      { l: '拍案', r: '叫绝', note: '拍案叫绝' },
      { l: '叹为', r: '观止', note: '叹为观止' },
      { l: '头头', r: '是道', note: '头头是道' },

      /* —— 做事的方法 —— */
      { l: '得心', r: '应手', note: '得心应手' },
      { l: '游刃', r: '有余', note: '游刃有余' },
      { l: '轻车', r: '熟路', note: '轻车熟路' },
      { l: '水到', r: '渠成', note: '水到渠成' },
      { l: '瓜熟', r: '蒂落', note: '瓜熟蒂落' },
      { l: '按图', r: '索骥', note: '按图索骥' },
      { l: '有的', r: '放矢', note: '有的放矢' },
      { l: '对症', r: '下药', note: '对症下药' },
      { l: '量体', r: '裁衣', note: '量体裁衣' },
      { l: '入乡', r: '随俗', note: '入乡随俗' },
      { l: '随遇', r: '而安', note: '随遇而安' },
      { l: '量力', r: '而行', note: '量力而行' },
      { l: '集思', r: '广益', note: '集思广益' },
      { l: '博采', r: '众长', note: '博采众长' },
      { l: '取长', r: '补短', note: '取长补短' },
      { l: '抽丝', r: '剥茧', note: '抽丝剥茧' },
      { l: '顺藤', r: '摸瓜', note: '顺藤摸瓜' },
      { l: '身体', r: '力行', note: '身体力行' },
      { l: '以身', r: '作则', note: '以身作则' },
      { l: '独当', r: '一面', note: '独当一面' },

      /* —— 自然与时序 —— */
      { l: '风平', r: '浪静', note: '风平浪静' },
      { l: '惊涛', r: '骇浪', note: '惊涛骇浪' },
      { l: '电闪', r: '雷鸣', note: '电闪雷鸣' },
      { l: '乌云', r: '密布', note: '乌云密布' },
      { l: '倾盆', r: '大雨', note: '倾盆大雨' },
      { l: '雨过', r: '天晴', note: '雨过天晴' },
      { l: '柳暗', r: '花明', note: '柳暗花明' },
      { l: '山穷', r: '水尽', note: '山穷水尽' },
      { l: '水落', r: '石出', note: '水落石出' },
      { l: '花好', r: '月圆', note: '花好月圆' },
      { l: '风和', r: '日丽', note: '风和日丽' },
      { l: '鸟语', r: '花香', note: '鸟语花香' },
      { l: '桃红', r: '柳绿', note: '桃红柳绿' },
      { l: '山清', r: '水秀', note: '山清水秀' },
      { l: '湖光', r: '山色', note: '湖光山色' },
      { l: '冰天', r: '雪地', note: '冰天雪地' },
      { l: '秋高', r: '气爽', note: '秋高气爽' },
      { l: '春华', r: '秋实', note: '春华秋实' },
      { l: '大地', r: '回春', note: '大地回春' },
      { l: '冰消', r: '瓦解', note: '冰消瓦解' },
      { l: '烟消', r: '云散', note: '烟消云散' },
      { l: '源远', r: '流长', note: '源远流长' },
      { l: '川流', r: '不息', note: '川流不息' },
      { l: '沧海', r: '桑田', note: '沧海桑田' },
      { l: '海枯', r: '石烂', note: '海枯石烂' },
      { l: '天涯', r: '海角', note: '天涯海角' },
      { l: '近在', r: '咫尺', note: '近在咫尺' },
      { l: '白驹', r: '过隙', note: '白驹过隙' },
      { l: '光阴', r: '似箭', note: '光阴似箭' },
      { l: '日月', r: '如梭', note: '日月如梭' },
      { l: '转瞬', r: '即逝', note: '转瞬即逝' },
      { l: '今非', r: '昔比', note: '今非昔比' },
      { l: '焕然', r: '一新', note: '焕然一新' },
      { l: '推陈', r: '出新', note: '推陈出新' },
      { l: '与时', r: '俱进', note: '与时俱进' },
      { l: '继往', r: '开来', note: '继往开来' },
      { l: '承前', r: '启后', note: '承前启后' },
      { l: '日新', r: '月异', note: '日新月异' },
      { l: '每况', r: '愈下', note: '每况愈下' },
      { l: '与日', r: '俱增', note: '与日俱增' },
      { l: '空前', r: '绝后', note: '空前绝后' },
      { l: '原封', r: '不动', note: '原封不动' },
      { l: '一成', r: '不变', note: '一成不变' },

      /* —— 品德、人际与创造 —— */
      { l: '开诚', r: '布公', note: '开诚布公' },
      { l: '同舟', r: '共济', note: '同舟共济' },
      { l: '众志', r: '成城', note: '众志成城' },
      { l: '齐心', r: '协力', note: '齐心协力' },
      { l: '同心', r: '同德', note: '同心同德' },
      { l: '肝胆', r: '相照', note: '肝胆相照' },
      { l: '患难', r: '与共', note: '患难与共' },
      { l: '守望', r: '相助', note: '守望相助' },
      { l: '雪中', r: '送炭', note: '雪中送炭' },
      { l: '锦上', r: '添花', note: '锦上添花' },
      { l: '落井', r: '下石', note: '落井下石' },
      { l: '推心', r: '置腹', note: '推心置腹' },
      { l: '莫逆', r: '之交', note: '莫逆之交' },
      { l: '萍水', r: '相逢', note: '萍水相逢' },
      { l: '素昧', r: '平生', note: '素昧平生' },
      { l: '饮水', r: '思源', note: '饮水思源' },
      { l: '知恩', r: '图报', note: '知恩图报' },
      { l: '以德', r: '报怨', note: '以德报怨' },
      { l: '宽宏', r: '大量', note: '宽宏大量' },
      { l: '虚怀', r: '若谷', note: '虚怀若谷' },
      { l: '戒骄', r: '戒躁', note: '戒骄戒躁' },
      { l: '大公', r: '无私', note: '大公无私' },
      { l: '两袖', r: '清风', note: '两袖清风' },
      { l: '一清', r: '二白', note: '一清二白' },
      { l: '克勤', r: '克俭', note: '克勤克俭' },
      { l: '省吃', r: '俭用', note: '省吃俭用' },
      { l: '自力', r: '更生', note: '自力更生' },
      { l: '助人', r: '为乐', note: '助人为乐' },
      { l: '乐善', r: '好施', note: '乐善好施' },
      { l: '深情', r: '厚谊', note: '深情厚谊' },
      { l: '恩重', r: '如山', note: '恩重如山' },
      { l: '眼见', r: '为实', note: '眼见为实' },
      { l: '开卷', r: '有益', note: '开卷有益' },
      { l: '手不', r: '释卷', note: '手不释卷' },
      { l: '一目', r: '十行', note: '一目十行' },
      { l: '过目', r: '不忘', note: '过目不忘' },
      { l: '倒背', r: '如流', note: '倒背如流' },
      { l: '深思', r: '熟虑', note: '深思熟虑' },
      { l: '天衣', r: '无缝', note: '天衣无缝' },
      { l: '巧夺', r: '天工', note: '巧夺天工' },
      { l: '鬼斧', r: '神工', note: '鬼斧神工' },
      { l: '匠心', r: '独运', note: '匠心独运' },
      { l: '别出', r: '心裁', note: '别出心裁' },
      { l: '别具', r: '一格', note: '别具一格' },
      { l: '独树', r: '一帜', note: '独树一帜' },
      { l: '标新', r: '立异', note: '标新立异' },
      { l: '自成', r: '一家', note: '自成一家' },
      { l: '万象', r: '更新', note: '万象更新' },
      { l: '欣欣', r: '向荣', note: '欣欣向荣' },
      { l: '蒸蒸', r: '日上', note: '蒸蒸日上' },
      { l: '多多', r: '益善', note: '多多益善' },
      { l: '不约', r: '而同', note: '不约而同' },
      { l: '不谋', r: '而合', note: '不谋而合' },
      { l: '不翼', r: '而飞', note: '不翼而飞' },
      { l: '不劳', r: '而获', note: '不劳而获' },
      { l: '不速', r: '之客', note: '不速之客' },
      { l: '半信', r: '半疑', note: '半信半疑' },
      { l: '无微', r: '不至', note: '无微不至' },
      { l: '无独', r: '有偶', note: '无独有偶' },
      { l: '出神', r: '入化', note: '出神入化' },
      { l: '登峰', r: '造极', note: '登峰造极' },
      { l: '炉火', r: '纯青', note: '炉火纯青' },
      { l: '目无', r: '全牛', note: '目无全牛' },
      { l: '走马', r: '观花', note: '走马观花' }
    ]
  };
})(typeof window !== 'undefined' ? window : globalThis);
